import { LoadingButton } from "@mui/lab";
import { Button, TextField } from "@mui/material";
import { isEmpty } from "lodash";
import React, { useCallback, useState } from "react";
import SideSheet, {
    SideSheetButtons,
    SideSheetContent,
    SideSheetContentPadding,
    SideSheetForm,
} from "../../components/SideSheet";
import { FormFieldErrors, hasErrors, useForm, validateMandatoryField } from "../../utils/form";
import { useUserInfo } from "../../utils/security";
import { CounterpartySelect } from "../counterparties";

export const PricelistModal = ({ data, onSubmit, open, hide }) => {
    const [loading, setLoading] = useState(false);
    const { userInfo } = useUserInfo();

    const onSubmitFn = useCallback(
        async (data) => {
            setLoading(true);
            try {
                onSubmit && (await onSubmit(data));
            } finally {
                setLoading(false);
            }
        },
        [onSubmit, setLoading]
    );

    const validate = useCallback((values, errors) => {
        validateMandatoryField(values.name, "name", errors);
        return errors;
    }, []);

    const { handleSubmit, handleChange, values, setValues, errors } = useForm({
        onSubmit: onSubmitFn,
        validate,
        data,
    });

    const counterparty = isEmpty(values.counterpartyId)
        ? null
        : {
              id: values.counterpartyId,
              name: values.counterpartyName,
          };

    return (
        <>
            <SideSheet title="Ceník" open={open} hide={hide} loading={loading}>
                <SideSheetForm onSubmit={handleSubmit}>
                    <SideSheetContent noPadding>
                        <SideSheetContentPadding>
                            <TextField
                                value={values.name}
                                onChange={handleChange}
                                name="name"
                                label="Název"
                                fullWidth
                                margin="normal"
                                required
                                error={hasErrors(errors, "name")}
                                helperText={<FormFieldErrors errors={errors} field="name" />}
                            />
                            {!!userInfo.counterpartiesSupport && (
                                <CounterpartySelect
                                    value={counterparty}
                                    onChange={(counterparty) => {
                                        if (isEmpty(counterparty)) {
                                            setValues({
                                                counterpartyId: null,
                                                counterpartyName: "",
                                            });
                                        } else {
                                            setValues({
                                                counterpartyId: counterparty.id,
                                                counterpartyName: counterparty.name,
                                            });
                                        }
                                    }}
                                    label="Klient"
                                    fullWidth
                                    margin="normal"
                                    disabled={loading}
                                    error={hasErrors(errors, "counterparty")}
                                    helperText={
                                        <FormFieldErrors errors={errors} field="counterparty" />
                                    }
                                />
                            )}
                            <TextField
                                value={values.description}
                                onChange={handleChange}
                                disabled={loading}
                                name="description"
                                label="Popis"
                                placeholder="Popis ceníku..."
                                fullWidth
                                multiline
                                rows={4}
                                margin="normal"
                                helperText={<FormFieldErrors errors={errors} field="description" />}
                            />
                        </SideSheetContentPadding>
                        {/* <SideSheetOptionalSection
                            name="active"
                            value={values.active}
                            onChange={handleChange}
                            disabled={loading}
                            title="Aktivní ceník"
                            description="Aktivní ceník lze použít pro vytváření cenových nabídek."
                            borderTop
                        /> */}
                    </SideSheetContent>
                    <SideSheetButtons>
                        <Button variant="outlined" onClick={(e) => hide?.()} disabled={loading}>
                            Storno
                        </Button>
                        <LoadingButton
                            variant="contained"
                            type="submit"
                            disabled={loading}
                            loading={loading}>
                            Uložit
                        </LoadingButton>
                    </SideSheetButtons>
                </SideSheetForm>
            </SideSheet>
        </>
    );
};
